import { Icon, IconButton } from '@yembo/yemblocks-core';
import { RefObject, useContext, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { OFFLINE_NOTIFICATION_MESSAGE } from './OnlineStatusProvider';
import { OnlineStatusContext } from './OnlineStatusProvider/context';

export const OfflineNotification = () => {
  const { shouldShowNotificationOnPage } = useContext(OnlineStatusContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const draggableRef = useRef<HTMLDivElement>(null); // Fixes https://github.com/react-grid-layout/react-draggable/issues/771#issuecomment-2545737391

  return (
    shouldShowNotificationOnPage && (
      <Draggable
        handle='#data-loss-notification-wrapper'
        bounds='parent'
        cancel='.toggle-collapse'
        nodeRef={draggableRef as RefObject<HTMLDivElement>}
      >
        <div id='data-loss-notification-wrapper' className={isCollapsed ? 'collapsed' : ''} ref={draggableRef}>
          <div className='data-loss-notification'>
            <Icon name='error' className='data-loss-icon' />
            {!isCollapsed && (
              <div>
                <p>{OFFLINE_NOTIFICATION_MESSAGE}</p>
              </div>
            )}
          </div>
          <div className='toggle-collapse'>
            <IconButton
              kind='flat'
              icon={<Icon name={isCollapsed ? 'add' : 'minus'} color='blue' />}
              onClick={() => setIsCollapsed(!isCollapsed)}
            />
          </div>
        </div>
      </Draggable>
    )
  );
};
